import Plugin from 'src/plugin-system/plugin.class';
import algoliasearch from 'algoliasearch/lite';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';

export default class SearchPlugin extends Plugin {

    init() {

        const searchClient = algoliasearch(
            'LG1TFOQ1WY',
            'fb36fadc7596983713737cee1a9657ec'
        );

        var that = this;

        var ac = autocomplete({
            container: '#autocomplete',
            //debug: true,
            detachedMediaQuery: 'none',
            placeholder: that.options.placeholder,
            getSources({ query }) {
              return [
                {
                  sourceId: 'products',
                  getItems() {
                    return getAlgoliaResults({
                      searchClient,
                      transformResponse({ hits }) {
                        var lang = "de";
                        if (that.options.lang) {
                          lang = that.options.lang;
                        }

                        var filteredHits = hits[0].filter(function (el) {
                          return el.language == lang;
                        });

                        return filteredHits;
                      },
                      queries: [
                        {
                          indexName: 'wp_searchable_posts',
                          query,
                          params: {
                            hitsPerPage: 5,
                            attributesToSnippet: ['name:10', 'description:35'],
                            snippetEllipsisText: '…',
                          },
                        },
                      ],
                    });
                  },
                  getItemUrl({ item }) {
                    return item.permalink;
                  },

                  templates: {
                    header() {
                        return that.options.header;
                    },
                    item({ item, createElement }) {
                        return <a href={item.permalink}>{item.post_title}</a>;
                    },
                  },
                },
              ];
            },
            onSubmit: function(event) {

              if (!event.state.query) {
                return;
              }

              window.location.href = that.options.search_url.replace('term', event.state.query);

            }
        });


        $('#searchModal').on('shown.bs.modal', function() {
            $('.aa-Input').focus();
        })

    }

}
